module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "billingManage"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "model": _vm.searchForm,
      "inline": true,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择开票状态",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.status),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "status", $$v)
      },
      expression: "searchForm.status"
    }
  }, _vm._l((_vm.pickingStatusList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "110px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "开票类型",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.type),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "type", $$v)
      },
      expression: "searchForm.type"
    }
  }, _vm._l((_vm.pickingTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "150px",
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "订单编号"
    },
    model: {
      value: (_vm.searchForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "orderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "140px",
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "开票申请编号"
    },
    model: {
      value: (_vm.searchForm.invoiceCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "invoiceCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.invoiceCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "140px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "申请人"
    },
    model: {
      value: (_vm.searchForm.staffName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "staffName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.staffName"
    }
  }, _vm._l((_vm.pickingUserAllList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.staffName,
        "value": item.staffName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "350px",
      "margin-bottom": "15px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "-",
      "default-time": ['00:00:00', '11:59:59'],
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.valueTime3),
      callback: function($$v) {
        _vm.valueTime3 = $$v
      },
      expression: "valueTime3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('searchForm')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.basicsAuth.apply_invoice) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.newModel()
      }
    }
  }, [_vm._v("新建")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "id": "tableId",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "开票申请编号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "active-code",
          on: {
            "click": function($event) {
              return _vm.checkModel(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.invoiceCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "orderNo",
      "width": "200",
      "label": "关联订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "invoiceAmount",
      "label": "开票金额(元)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '1') ? _c('span', [_vm._v("专票")]) : _vm._e(), _vm._v(" "), (scope.row.type == '2') ? _c('span', [_vm._v("普票")]) : _vm._e(), _vm._v(" "), (scope.row.type == '3') ? _c('span', [_vm._v("电子普票")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dutyParagraph",
      "align": "center",
      "label": "纳税人编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "开票状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == '2') ? _c('span', [_vm._v("审核中")]) : _vm._e(), _vm._v(" "), (scope.row.status == '3') ? _c('span', [_vm._v("已开票")]) : _vm._e(), _vm._v(" "), (scope.row.status == '4') ? _c('span', [_vm._v("已驳回")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staffName",
      "align": "center",
      "label": "申请人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "label": "提交时间"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textModelMenu[_vm.dialogModelStatus],
      "visible": _vm.dislogModel,
      "close-on-click-modal": false,
      "width": "600px",
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogModel = $event
      },
      "close": function($event) {
        return _vm.emptyModelDialog('modelForm')
      }
    }
  }, [_c('el-form', {
    ref: "modelForm",
    attrs: {
      "model": _vm.modelForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.modelFormRules
    }
  }, [(!_vm.isReject) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "关联工单",
      "prop": "orderNo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入关联工单(不超过30个字)",
      "maxlength": "30"
    },
    model: {
      value: (_vm.modelForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "orderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择开票类型",
      "clearable": ""
    },
    model: {
      value: (_vm.modelForm.type),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "type", $$v)
      },
      expression: "modelForm.type"
    }
  }, _vm._l((_vm.pickingTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票金额",
      "prop": "invoiceAmount"
    }
  }, [_c('el-input', {
    staticClass: "yuan",
    attrs: {
      "clearable": "",
      "oninput": "this.value=this.value.replace(/\\D/g,'').replace(/^0{1,}/g,'')",
      "placeholder": "请输入开票金额",
      "maxlength": "6"
    },
    model: {
      value: (_vm.modelForm.invoiceAmount),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "invoiceAmount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.invoiceAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票抬头",
      "prop": "invoiceTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入开票抬头(不超过50个字)",
      "maxlength": "50"
    },
    model: {
      value: (_vm.modelForm.invoiceTitle),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "invoiceTitle", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.invoiceTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税编号",
      "prop": "dutyParagraph"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入纳税编号(不超过100个字)",
      "maxlength": "100"
    },
    model: {
      value: (_vm.modelForm.dutyParagraph),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "dutyParagraph", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.dutyParagraph"
    }
  })], 1), _vm._v(" "), (_vm.dialogModelStatus == 'create') ? _c('el-form-item', {
    attrs: {
      "label": "相关图片"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "data": _vm.postData,
      "auto-upload": false,
      "action": "https://up.qiniup.com",
      "list-type": "picture-card",
      "accept": _vm.acceptImage,
      "on-success": _vm.handleModelAvatarSuccess,
      "on-remove": _vm.handleRemove,
      "on-preview": _vm.handlePreview,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，且不超过5Mb")])])], 1) : _vm._e(), _vm._v(" "), (_vm.dialogModelStatus == 'update') ? _c('el-form-item', {
    attrs: {
      "label": "相关图片"
    }
  }, [_c('el-upload', {
    ref: "update",
    staticClass: "avatar-uploader hide-upload",
    attrs: {
      "action": "https://up.qiniup.com",
      "disabled": "",
      "list-type": "picture-card",
      "file-list": _vm.fileList,
      "on-preview": _vm.handlePreview
    }
  })], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.dialogModelStatus == 'create' && !_vm.isReject) ? _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.getOrderListData
    }
  }, [_vm._v("提交申请")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyModelDialog('modelForm')
      }
    }
  }, [_vm._v("取 消")])], 1) : _vm._e(), _vm._v(" "), (_vm.dialogModelStatus == 'update' && _vm.isReject) ? _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.confirmBtn(0)
      }
    }
  }, [_vm._v("确认")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-0dd8a782","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workOrder/billingManage.vue
// module id = 1580
// module chunks = 0